import React from "react";

function Fresh() {
    return (
    < div >
        {/* ======= Header ======= */}
        < header id="header" className="fixed-top ">
            <div className="container d-flex align-items-center justify-content-lg-between">
                {<a href="index.html" class="logo me-auto me-lg-0"><img src="assets/img/aa5logo.png" alt="" class="img-fluid" /></a>}
                <nav id="navbar" className="navbar order-last order-lg-0">
                    <ul>
                        <li><a className="nav-link scrollto active" href="#hero">Home</a></li>
                        <li><a className="nav-link scrollto" href="#about">About</a></li>
                        <li><a className="nav-link scrollto" href="#services">Services</a></li>
                        <li><a className="nav-link scrollto " href="#portfolio">Projects</a></li>
                        <li><a className="nav-link scrollto" href="#contact">Contact</a></li>
                    </ul>
                    <i className="bi bi-list mobile-nav-toggle" />
                </nav>{/* .navbar */}
            </div>
        </header > {/* End Header */}
        {/* ======= Hero Section ======= */}
        <section id="hero" className="d-flex align-items-center justify-content-center">
            <div className="container" data-aos="fade-up">
                <div className="row justify-content-center" data-aos="fade-up" data-aos-delay={150}>
                    <div className="col-xl-6 col-lg-8">
                        <h1>Let us Bring your Vision to Life<span>!</span></h1>
                    </div>
                </div>
            </div>
        </section> {/* End Hero */}
        <main id="main">
            {/* ======= About Section ======= */}
            <section id="about" className="about">
                <div className="container" data-aos="fade-up">
                    <div className="row">
                        <div className="col-lg-6 order-1 order-lg-2" data-aos="fade-left" data-aos-delay={100}>
                            <img src="assets/img/aa5logo.png" className="img-fluid" alt="" />
                        </div>
                        <div className="col-lg-6 pt-4 pt-lg-0 order-2 order-lg-1 content" data-aos="fade-right" data-aos-delay={100}>
                            <h3>Welcome to AA5 Motorsports</h3>
                            <p className="fst-italic">
                                At AA5 Motorsports, we are your trusted partner when it comes to auto body repairs, collision restoration, and vehicle customization. With years of experience and a team of skilled technicians, we are committed to delivering top-notch services that restore your vehicle to its pre-accident condition and enhance its aesthetics
                            </p>
                            <ul>
                                <li><i className="ri-check-double-line" />1. Expertise: Our team consists of highly trained and experienced auto body technicians who are passionate about what they do. They stay up-to-date with the latest industry techniques and technologies to ensure the best results for your vehicle.</li>
                                <li><i className="ri-check-double-line" /> 2. Quality Workmanship: We take pride in our craftsmanship. From paint matching to dent repair and frame straightening, our attention to detail is unparalleled.</li>
                                <li><i className="ri-check-double-line" /> 3. Customer-Centric Approach: We prioritize open communication and transparency. We'll keep you informed throughout the repair process and answer any questions you may have.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>{/* End About Section */}
            {/* ======= Features Section ======= */}
            <section id="features" className="features">
                <div className="container" data-aos="fade-up">
                    <div className="row">
                        <div className="image col-lg-6" style={{ backgroundImage: 'url("assets/img/maybach.jpeg")' }} data-aos="fade-right" />
                        <div className="col-lg-6" data-aos="fade-left" data-aos-delay={100}>
                            <div className="icon-box mt-5 mt-lg-0" data-aos="zoom-in" data-aos-delay={150}>
                                <h4>Collision Repair:</h4>
                                <p> Accidents happen, and when they do, trust us to restore your vehicle to its pre-accident condition. From minor fender benders to major collisions, we handle it all..</p>
                            </div>
                            <div className="icon-box mt-5" data-aos="zoom-in" data-aos-delay={150}>
                                <h4>Rentals:</h4>
                                <p> Assistance in arranging rental cars if your vehicle needs extended repairs.</p>
                            </div>
                            <div className="icon-box mt-5" data-aos="zoom-in" data-aos-delay={150}>
                                <h4>Customization:</h4>
                                <p>Make your vehicle uniquely yours with our customization services. From vinyl wraps and graphics to performance enhancements, we can bring your vision to life.</p>
                            </div>
                            <div className="icon-box mt-5" data-aos="zoom-in" data-aos-delay={150}>
                                <h4>Vehicle Wraps</h4>
                                <p>Turn heads wherever you go with a custom vehicle wrap. Choose from a wide range of colors, textures, and finishes to create a unique look for your vehicle.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>{/* End Features Section */}
            {/* ======= Services Section ======= */}
            <section id="services" className="services">
                <div className="container" data-aos="fade-up">
                    <div className="section-title">
                        <h2>Services</h2>
                        <p>Check our Services</p>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay={100}>
                            <div className="icon-box">
                                <img src="assets/img/icons/insurance.jpg" className="img-fluid" alt="" />
                                <h4><a href>Insurance Claims Assistance</a></h4>
                                <p>Assisting customers with the insurance claims process for accident-related repairs.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mt-md-0" data-aos="zoom-in" data-aos-delay={200}>
                            <div className="icon-box">
                                <img src="assets/img/icons/brakes2.jpg" className="img-fluid" alt="" />
                                <h4><a href>Mechanical Repairs</a></h4>
                                <p>We also offer basic mechanical repairs, such as brake and suspension work.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mt-lg-0" data-aos="zoom-in" data-aos-delay={300}>
                            <div className="icon-box">
                                <img src="assets/img/icons/cclass.jpg" className="img-fluid" alt="" />
                                <h4><a href>Towing Services</a></h4>
                                <p>Providing towing services for vehicles that cannot be driven to the shop.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4" data-aos="zoom-in" data-aos-delay={100}>
                            <div className="icon-box">
                                <img src="assets/img/g80wash.jpg" className="img-fluid" alt="" />
                                <h4><a href>Detailing Services</a></h4>
                                <p>Providing interior and exterior detailing to keep vehicles looking their best, including waxing, polishing, and upholstery cleaning.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4" data-aos="zoom-in" data-aos-delay={200}>
                            <div className="icon-box">
                                <img src="assets/img/shantg80.jpeg" className="img-fluid" alt="" />
                                <h4><a href>Customization and Body Kits</a></h4>
                                <p>Offering custom body modifications, such as body kits, spoilers, and aftermarket accessories.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4" data-aos="zoom-in" data-aos-delay={300}>
                            <div className="icon-box">
                                <img src="assets/img/ppfrarri.jpg" className="img-fluid" alt="" />
                                <h4><a href>Paint Protection Film (PPF) Installation</a></h4>
                                <p>Applying PPF to protect a vehicle's paint from chips, scratches, and environmental damage.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>{/* End Services Section */}
            {/* ======= Cta Section ======= */}
            <section id="cta" className="cta">
                <div className="container" data-aos="zoom-in">
                    <div className="text-center">
                        <h3>Follow us on Instagram: @aa5motorsports</h3>
                    </div>
                </div>
            </section>{/* End Cta Section */}
            {/* ======= Portfolio Section ======= */}
            <section id="portfolio" className="portfolio">
                <div className="container" data-aos="fade-up">
                    <div className="section-title">
                        <h2>Projects</h2>
                        <p>Check out some of our Projects</p>
                    </div>
                    <div className="row" data-aos="fade-up" data-aos-delay={100}>
                        <div className="col-lg-12 d-flex justify-content-center">
                            <ul id="portfolio-flters">
                                <li data-filter="*" className="filter-active">All</li>
                            </ul>
                        </div>
                    </div>
                    <div className="row portfolio-container" data-aos="fade-up" data-aos-delay={200}>
                        <div className="col-lg-4 col-md-6 portfolio-item filter-app">
                            <div className="portfolio-wrap">
                                <img src="assets/img/urus.JPG" className="img-fluid" alt="" />
                                <div className="portfolio-info">
                                    <h4>Lamborghini Urus</h4>
                                    <p></p>
                                    <div className="portfolio-links">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 portfolio-item filter-web">
                            <div className="portfolio-wrap">
                                <img src="assets/img/bigyash.JPG" className="img-fluid" alt="" />
                                <div className="portfolio-info">
                                    <h4>G63 4x4</h4>
                                    <p></p>
                                    <div className="portfolio-links">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 portfolio-item filter-app">
                            <div className="portfolio-wrap">
                                <img src="assets/img/horomartin.jpeg" className="img-fluid" alt="" />
                                <div className="portfolio-info">
                                    <h4>Aston Martin DBX</h4>
                                    <p></p>
                                    <div className="portfolio-links">

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 portfolio-item filter-card">
                            <div className="portfolio-wrap">
                                <img src="assets/img/g90.jpg" className="img-fluid" alt="" />
                                <div className="portfolio-info">
                                    <h4>BMW G90 M5</h4>
                                    <p></p>
                                    <div className="portfolio-links">

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 portfolio-item filter-web">
                            <div className="portfolio-wrap">
                                <img src="assets/img/reshaped.jpg" className="img-fluid" alt="" />
                                <div className="portfolio-info">
                                    <h4>BMW G80 M3 Competition</h4>
                                    <div className="portfolio-links">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 portfolio-item filter-app">
                            <div className="portfolio-wrap">
                                <img src="assets/img/annam4.jpeg" className="img-fluid" alt="" />
                                <div className="portfolio-info">
                                    <h4>BMW F82 M4CS</h4>
                                    <div className="portfolio-links">

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 portfolio-item filter-card">
                            <div className="portfolio-wrap">
                                <img src="assets/img/gors63.jpeg" className="img-fluid" alt="" />
                                <div className="portfolio-info">
                                    <h4>Mercedes-Benz S63 E Performance</h4>
                                    <div className="portfolio-links">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 portfolio-item filter-card">
                            <div className="portfolio-wrap">
                                <img src="assets/img/mclaren aa5.jpeg" className="img-fluid" alt="" />
                                <div className="portfolio-info">
                                    <h4>Mclaren Artura</h4>
                                    <div className="portfolio-links">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 portfolio-item filter-web">
                            <div className="portfolio-wrap">
                                <img src="assets/img/johnnyturbo.jpeg" className="img-fluid" alt="" />
                                <div className="portfolio-info">
                                    <h4>Porsche 911 Turbo S</h4>
                                    <div className="portfolio-links">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>{/* End Portfolio Section */}
            {/* ======= Counts Section ======= */}
            <section id="counts" className="counts">
                <div className="container" data-aos="fade-up">
                    <div className="row no-gutters">
                        <div className="image col-xl-5 d-flex align-items-stretch justify-content-center justify-content-lg-start" data-aos="fade-right" data-aos-delay={100} />
                        <div className="col-xl-7 ps-4 ps-lg-5 pe-4 pe-lg-1 d-flex align-items-stretch" data-aos="fade-left" data-aos-delay={100}>
                            <div className="content d-flex flex-column justify-content-center">
                                <h3>More About Us</h3>
                                <div className="row">
                                    <div className="col-md-6 d-md-flex align-items-md-stretch">
                                        <div className="count-box">
                                            <i className="bi bi-emoji-smile" />
                                            <span data-purecounter-start={0} data-purecounter-end={65} data-purecounter-duration={2} className="purecounter" />
                                            <p><strong>Happy Clients</strong> We take pride in our commitment to customer satisfaction. Our team of skilled technicians works tirelessly to ensure that every client leaves with a smile on their face.</p>
                                        </div>
                                    </div>
                                    <div className="col-md-6 d-md-flex align-items-md-stretch">
                                        <div className="count-box">
                                            <i className="bi bi-journal-richtext" />
                                            <span data-purecounter-start={0} data-purecounter-end={85} data-purecounter-duration={2} className="purecounter" />
                                            <p><strong>Free Estimates:</strong> Providing free initial estimates for repairs or damage assessment.</p>
                                        </div>
                                    </div>
                                    <div className="col-md-6 d-md-flex align-items-md-stretch">
                                        <div className="count-box">
                                            <i className="bi bi-clock" />
                                            <span data-purecounter-start={0} data-purecounter-end={35} data-purecounter-duration={4} className="purecounter" />
                                            <p><strong>Years of experience</strong> With years of experienced auto technicians, our team brings a wealth of knowledge and expertise to every repair and maintenance service we provide.</p>
                                        </div>
                                    </div>
                                    <div className="col-md-6 d-md-flex align-items-md-stretch">
                                        <div className="count-box">
                                            <i className="bi bi-award" />
                                            <span data-purecounter-start={0} data-purecounter-end={20} data-purecounter-duration={4} className="purecounter" />
                                            <p><strong>Excellent Customer Service:</strong> Friendly and knowledgeable staff who can address customer questions and concerns.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>{/* End .content*/}
                        </div>
                    </div>
                </div>
            </section>{/* End Counts Section */}
            {/* ======= Testimonials Section ======= */}
            <section id="testimonials" className="testimonials">
                <div className="container" data-aos="zoom-in">
                    <div className="testimonials-slider swiper" data-aos="fade-up" data-aos-delay={100}>
                        <div className="swiper-wrapper">
                            <div className="swiper-slide">
                                <div className="testimonial-item">
                                    <h1>
                                        Ready to experience the AA5 Motorsports difference? Contact us today to schedule an appointment or request a free estimate. Our team is here to ensure your car looks and performs its best.
                                    </h1>
                                </div>
                            </div>{/* End testimonial item */}
                            <div className="swiper-slide">
                                <div className="testimonial-item">
                                    <img src="assets/img/testimonials/testimonials-2.jpg" className="testimonial-img" alt="" />
                                    <h3>Sara Wilsson</h3>
                                    <h4>Designer</h4>
                                    <p>
                                        <i className="bx bxs-quote-alt-left quote-icon-left" />
                                        Export tempor illum tamen malis malis eram quae irure esse labore quem cillum quid cillum eram malis quorum velit fore eram velit sunt aliqua noster fugiat irure amet legam anim culpa.
                                        <i className="bx bxs-quote-alt-right quote-icon-right" />
                                    </p>
                                </div>
                            </div>{/* End testimonial item */}
                            <div className="swiper-slide">
                                <div className="testimonial-item">
                                    <img src="assets/img/testimonials/testimonials-3.jpg" className="testimonial-img" alt="" />
                                    <h3>Jena Karlis</h3>
                                    <h4>Store Owner</h4>
                                    <p>
                                        <i className="bx bxs-quote-alt-left quote-icon-left" />
                                        Enim nisi quem export duis labore cillum quae magna enim sint quorum nulla quem veniam duis minim tempor labore quem eram duis noster aute amet eram fore quis sint minim.
                                        <i className="bx bxs-quote-alt-right quote-icon-right" />
                                    </p>
                                </div>
                            </div>{/* End testimonial item */}
                            <div className="swiper-slide">
                                <div className="testimonial-item">
                                    <img src="assets/img/testimonials/testimonials-4.jpg" className="testimonial-img" alt="" />
                                    <h3>Matt Brandon</h3>
                                    <h4>Freelancer</h4>
                                    <p>
                                        <i className="bx bxs-quote-alt-left quote-icon-left" />
                                        Fugiat enim eram quae cillum dolore dolor amet nulla culpa multos export minim fugiat minim velit minim dolor enim duis veniam ipsum anim magna sunt elit fore quem dolore labore illum veniam.
                                        <i className="bx bxs-quote-alt-right quote-icon-right" />
                                    </p>
                                </div>
                            </div>{/* End testimonial item */}
                            <div className="swiper-slide">
                                <div className="testimonial-item">
                                    <img src="assets/img/testimonials/testimonials-5.jpg" className="testimonial-img" alt="" />
                                    <h3>John Larson</h3>
                                    <h4>Entrepreneur</h4>
                                    <p>
                                        <i className="bx bxs-quote-alt-left quote-icon-left" />
                                        Quis quorum aliqua sint quem legam fore sunt eram irure aliqua veniam tempor noster veniam enim culpa labore duis sunt culpa nulla illum cillum fugiat legam esse veniam culpa fore nisi cillum quid.
                                        <i className="bx bxs-quote-alt-right quote-icon-right" />
                                    </p>
                                </div>
                            </div>{/* End testimonial item */}
                        </div>
                        <div className="swiper-pagination" />
                    </div>
                </div>
            </section>{/* End Testimonials Section */}
            {/* ======= Contact Section ======= */}
            <section id="contact" className="contact">
                <div className="container" data-aos="fade-up">
                    <div className="section-title">
                        <h2>Contact</h2>
                        <p>Contact Us</p>
                    </div>
                    <div>
                        <iframe style={{ border: 0, width: '100%', height: '270px' }} src="https:www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3300.697112213069!2d-118.44322142436994!3d34.17966087310927!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c297ab271b5d1d%3A0x68b323399acee4e8!2s14123%20Oxnard%20St%2C%20Van%20Nuys%2C%20CA%2091401!5e0!3m2!1sen!2sus!4v1697485501524!5m2!1sen!2sus" ></iframe>
                        <div className="row mt-5">
                            <div className="col-lg-4">
                                <div className="info">
                                    <div className="address">
                                        <i className="bi-geo-alt" />
                                        <h4>Location</h4>
                                        <p>14123 Oxnard st, Los Angeles, California</p>
                                    </div>
                                    <div className="email">
                                        <i className="bi-envelope" />
                                        <h4>Email</h4>
                                        <p>aamotorsports5@gmail.com</p>
                                    </div>
                                    <div className="phone">
                                        <i className="bi-phone" />
                                        <h4>Call</h4>
                                        <p>  +1(818)4500055</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>{/* End Contact Section */}
        </main>{/* End #main */}
        {/* ======= Footer ======= */}
        <footer id="footer">
            <div className="footer-top">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-info">
                                <h3>AA5<span> MOTORSPORTS</span></h3>
                                <p>
                                    14123 Oxnard st<br />
                                    Los Angeles, California<br /><br />
                                    <strong>Phone :</strong> +1 (818) 4500055<br />
                                    <strong>Email : </strong> aamotorsports5@gmail.com<br />
                                </p>
                                <div className="social-links mt-3">
                                    <a href="https://www.instagram.com/aa5motorsports/" className="instagram"><i className="bx bxl-instagram"></i></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-6 footer-links">
                            <h4>Useful Links</h4>
                            <ul>
                                <li><i className="bx bx-chevron-right"></i> <a href="home.html">Home</a></li>
                                <li><i className="bx bx-chevron-right"></i> <a href="#about">About us</a></li>
                                <li><i className="bx bx-chevron-right"></i> <a href="#services">Services</a></li>
                            </ul>
                        </div>
                        <div className="col-lg-4 col-md-6 footer-newsletter">
                            <h1><span>Let us bring your vision to life!</span></h1>
                        </div>
                    </div>
                </div>
            </div>
        </footer>{/* End Footer */}
    </div >

    )
}

export default Fresh;